module.exports = __webpack_public_path__ + "img/unpaywall-metrics-logo.6b201149.png";